<template>
  <div class="industry-list">
    <div v-if="showFilter" class="filter-bar">
      <el-form :inline="true" size="small">
        <el-form-item label="类型名称">
          <el-input
            v-model="searchName"
            placeholder="请输入类型名称"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="listData"
      style="width: 100%"
      size="small"
      border
      stripe
      :header-cell-style="{ background: '#545c64', color: '#fff' }"
    >
      <el-table-column prop="name" label="类型名称"></el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="$emit('add-child', scope.row)"
            >新增子类型</el-button
          >
          <el-button type="primary" size="mini" @click="$emit('edit', scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page="page"
      :page-sizes="[10, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      size="small"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "IndustryList",
  props: {
    pid: {
      type: [Number, String],
      default: "",
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      searchName: "",
      listData: [],
      total: 0,
    };
  },
  watch: {
    pid() {
      this.refresh();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchName,
      };
      if (this.pid !== "" && this.pid !== undefined && this.pid !== null) {
        params.pid = this.pid;
      }
      this.$axios
        .post("/api/shop_industry/industry_list", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data || {};
            this.listData = data.list || [];
            this.total = data.totalRow || 0;
          }
        });
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    handleSearch() {
      this.page = 1;
      this.getData();
    },
    handleReset() {
      this.searchName = "";
      this.page = 1;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getData();
    },
    handleDelete(row) {
      this.$confirm("确定删除该类型吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/api/shop_industry/del", this.$qs.stringify({ id: row.id }))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("删除成功");
                this.getData();
                this.$emit("changed");
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.industry-list {
  .filter-bar {
    margin-bottom: 10px;
  }
  .el-pagination {
    margin-top: 10px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shopIndustry/IndustryList.vue